import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentNetbankingComponent } from './payment-netbanking.component';
import { PaymentMethodListModule } from '../payment-method-list/payment-method-list.module';
import { PaymentMethodDropdownModule } from '../payment-method-dropdown/payment-method-dropdown.module';
import { PaymentOtherMethodListModule } from '../payment-other-method-list/payment-other-method-list.module';



@NgModule({
  declarations: [
    PaymentNetbankingComponent
  ],
  exports: [
    PaymentNetbankingComponent
  ],
  imports: [
    CommonModule,
    PaymentMethodDropdownModule,
    PaymentMethodListModule,
    PaymentOtherMethodListModule
  ]
})
export class PaymentNetbankingModule { }
